// extracted by mini-css-extract-plugin
export var container = "_t8-0";
export var table = "_t8-2";
export var tableWrapper = "_t8-1";